<template>
  <b-card-code class="grafica-ciudades">
    <b-row>
     
      <b-col cols="6">
        <div id="chart">
          <apexchart
            type="bar"
            height="400"
            :options="chartVentasPorTipo"
            :series="[{ data: seriesVentasPorTipo }]"
          />
        </div>
      </b-col>
      <b-col cols="6">
        <div id="chart">
          <apexchart
            type="bar"
            height="400"
            :options="chartTopProductos"
            :series="[{ data: seriesTopProductos }]"
          ></apexchart>
        </div>

      </b-col> 
    </b-row>
    <b-row>
      <b-col cols="12">
        <div id="chart">
          <apexchart
            type="line"
            height="400"
            :options="chartVentasPorFecha"
            :series="seriesVentasPorFecha"
          />
        </div>
      </b-col>
    </b-row>
    <b-row class="justify-content-center">
      <b-col cols="4">
        <b-form-group label="Selecciona un país:" class="select-moderno">
          <v-select
            v-model="paisSeleccionado"
            :options="opcionesPaises"
            label="text"
            :reduce="(o) => o.value"
            :clearable="false"
            placeholder="País"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">                        
        <div id="chart">         
          <apexchart
            type="pie"
            height="400"
            :options="chartVentasPorCiudad"
            :series="seriesVentasPorCiudad"
          ></apexchart>
        
        </div>
      </b-col>
      <b-col cols="4">       
        <div id="chart">
          <apexchart
            type="bar"
            height="400"
            :options="chartVentasPorTipoPais"
            :series="[{ data: seriesVentasPorTipoPais }]"
          />
        </div>
      </b-col>    
      <b-col cols="4">
        <div id="chart">
          <apexchart
            type="bar"
            height="400"
            :options="chartTopProductosPais"
            :series="[{ data: seriesTopProductosPais }]"
          ></apexchart>
        </div>
      </b-col> 
    </b-row>
    <b-row class="justify-content-center">
      <b-col cols="4">
        <b-form-group :label="'Selecciona una ciudad de ' + paisSeleccionado + ':'" class="select-moderno">
          <v-select
            v-model="ciudadSeleccionada"
            :options="opcionesCiudades"
            label="text"
            :reduce="(o) => o.value"
            :clearable="false"
            placeholder="Ciudad"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div id="chart">
          <apexchart
            type="line"
            height="400"
            :options="chartVentasPorFechaPais"
            :series="seriesVentasPorFechaPais"
          />
        </div>
      </b-col>
    </b-row>
  </b-card-code>
</template>
  
  <script>
/*import VueApexCharts from 'vue-apexcharts'*/

import BCardCode from "@core/components/b-card-code";
import { legend } from "echarts/lib/theme/dark";

import VueSlider from "vue-slider-component";
import vSelect from "vue-select";

export default {
  components: {
    VueSlider,
    BCardCode,
    vSelect,
  },
  data() {
    return {
      paisSeleccionado: null,
      opcionesPaises: [],
      opcionesCiudades: [],
      ciudadSeleccionada: null,
      coloresGrafica: [
        "#eb6170",
        "#2586ed",
        "#8772d1",
        "#e0914c",
        "#6399c1",
        "#f9fa66",
        "#e0684c",
        "#146799",
        "#ecbd49",
        "#E322B5",
        "#1FFF00",
        "#eb6170",
        "#2586ed",
        "#8772d1",
        "#e0914c",
        "#6399c1",
        "#f9fa66",
        "#e0684c",
        "#146799",
        "#ecbd49",
        "#E322B5",
        "#1FFF00",
        "#eb6170",
        "#2586ed",
        "#8772d1",
        "#e0914c",
        "#6399c1",
        "#f9fa66",
        "#e0684c",
        "#146799",
        "#ecbd49",
        "#eb6170",
        "#E322B5",
        "#1FFF00",
      ],
      seriesVentasPorCiudad: [0, 0],
      chartVentasPorCiudad: {
        chart: {
          type: "pie",
          height: 400,
          stacked: true,
          //stackType: "100%"
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#ffffff"],
            fontWeight: "bold",
          },
        },
        legend: {
          show: true,
        },
        stroke: {
          width: 2,
          colors: ["#fff"],
        },
        title: {
          text: "Ventas por País",
          align: "middle",
        },
        colors: this.coloresGrafica,
      },
      orders: [],
      seriesVentasPorTipo: [],
      seriesVentasPorTipoDinero: [],
      chartVentasPorTipo: {},
      chartVentasPorTipoDinero: {},
      seriesVentasPorTipoPais: [],
      chartVentasPorTipoPais:{},
      seriesVentasPorFecha: [],
      seriesVentasPorFechaPais: [],
      chartVentasPorFecha: {},
      chartVentasPorFechaPais: {},
      seriesTopProductos: [],
      chartTopProductos: {},
      seriesTopProductosPais: [],
      chartTopProductosPais: {},
      seriesTopProductosBubble: [],
      chartTopProductosBubble: {},
      tipoDatos: "Libras",
    };
  },
  props: ["items", "tipoDatosCalcular"],
  methods: {
    calcularGraficaStacked() {
      const datos = {};
      const paisesSet = new Set();
      const tiposSet = new Set();

      this.orders.forEach((order) => {
        const country = order.shipping_address?.country || "Desconocido";

        paisesSet.add(country);

        order.line_items.forEach((item) => {
          const tipo = item.product_type || "Desconocido";

          if (tipo === "Desconocido") {
            console.warn(`Producto sin tipo en el pedido ${order.id}:`, item);
          }

          tiposSet.add(tipo);

          if (!datos[tipo]) datos[tipo] = {};
          if (!datos[tipo][country]) datos[tipo][country] = 0;

          datos[tipo][country] += item.quantity;
        });
      });

      let total = 0;

      const totalPorPais = {};
      this.orders.forEach((order) => {
        const country = order.shipping_address?.country || "Desconocido";
        order.line_items.forEach((item) => {
          if (!totalPorPais[country]) totalPorPais[country] = 0;
          totalPorPais[country] += item.quantity;
          total += item.quantity;
        });
      });

      const paises = Array.from(paisesSet).sort(
        (a, b) => totalPorPais[b] - totalPorPais[a]
      );
      const tipos = Array.from(tiposSet);

      const paisesOrdenados = Array.from(paisesSet).sort(
        (a, b) => totalPorPais[b] - totalPorPais[a]
      );

      const top10Paises = paisesOrdenados.slice(0, 10);
      const paisesConTotal = top10Paises.map(
        (pais) => `${pais} (${totalPorPais[pais]})`
      );

      const series = data;

      const chartVentas = {
        chart: {
          type: "pie",
          height: 400,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        stroke: {
          width: 2,
          colors: ["#fff"],
        },
        xaxis: {
          categories: paisesConTotal,
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "center",
          offsetX: 40,
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#ffffff"],
            fontWeight: "bold",
          },
        },
        title: {
          text: `Ventas por Ciudad (${total})`,
          align: "middle",
        },
      };

      this.chartVentasPorCiudad = chartVentas;
      this.seriesVentasPorCiudad = series;
    },
    calcularGraficaPorCiudad() {
  const pais = this.paisSeleccionado;
  const datosCiudad = {};
  let total = 0;

  this.orders.forEach((order) => {
    const country = order.shipping_address?.country;
    if (country !== pais) return;

    const city = order.shipping_address?.city || "Desconocida";

    order.line_items.forEach((item) => {
      const precio = parseFloat(item.price) || 0;
      const cantidad = Number(item.quantity) || 0;
      const importe = precio * cantidad;

      if (!datosCiudad[city]) datosCiudad[city] = 0;

      if (this.tipoDatos === "Libras") {
        datosCiudad[city] += importe;
        total += importe;
      } else {
        datosCiudad[city] += cantidad;
        total += cantidad;
      }
    });
  });

  const ciudadesOrdenadas = Object.entries(datosCiudad)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);

  const ciudades = ciudadesOrdenadas.map(([ciudad, valor]) =>
    this.tipoDatos === "Libras"
      ? `${ciudad} (£${valor.toFixed(0)})`
      : `${ciudad} (${valor})`
  );

  const cantidades =
    this.tipoDatos === "Libras"
      ? ciudadesOrdenadas.map(([_, valor]) => parseFloat(valor.toFixed(0)))
      : ciudadesOrdenadas.map(([_, valor]) => valor);

  const unidad = this.tipoDatos === "Libras" ? "£" : "ventas";

  this.seriesVentasPorCiudad = cantidades;
  this.chartVentasPorCiudad = {
    chart: {
      type: "pie",
      height: 350,
      events: {
        dataPointSelection: (e, ctx, { dataPointIndex }) => {
          this.$emit("filtrar", { pais, ciudad: ciudadesOrdenadas[dataPointIndex][0] });
        },
      },
    },
    labels: ciudades,
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        // val es el % del sector; los sectores pequeños no llevan etiqueta (el valor está en la leyenda)
        return val < 4 ? "" : opts.w.globals.series[opts.seriesIndex];
      },
      style: {
        fontWeight: "bold",
        colors: ["#ffffff"],
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `${val} ${unidad}`;
        },
      },
    },
    stroke: {
      width: 2,
      colors: ["#fff"],
    },
    title: {
      text: `Ventas por Ciudad en ${pais} (${this.tipoDatos === "Libras" ? "£" + total.toFixed(0) : total + " ventas"})`,
      align: "middle",
    },
    legend: {
      show: true,
    },
    colors: this.coloresGrafica,
  };
},

    calcularGraficaPorTipoProducto() {

      const tiposBase = ["Sleeves", "Accessories", "Bags", "Wallets"];
      const tiposSet = new Set(tiposBase); // Set que asegura tipos mínimos
      const datosTipo = {};
      let total = 0;

      this.orders.forEach((order) => {
        order.line_items.forEach((item) => {
          const tipo = item.product_type || "Desconocido";
          if (tipo === "Desconocido") return;

          tiposSet.add(tipo); // asegurar que está en el Set

          const precio = parseFloat(item.price) || 0;
          const cantidad = Number(item.quantity) || 0;
          const importe = precio * cantidad;

          if (this.tipoDatos === "Libras") {
            if (!datosTipo[tipo]) datosTipo[tipo] = 0;
            datosTipo[tipo] += importe;
            total += importe;
          } else {
            if (!datosTipo[tipo]) datosTipo[tipo] = 0;
            datosTipo[tipo] += item.quantity;
            total += item.quantity;
          }
        });
      });

      tiposBase.forEach((tipo) => {
        if (!datosTipo[tipo]) datosTipo[tipo] = 0;
      });

      const tipos = [
        ...tiposBase,
        ...Object.keys(datosTipo).filter((t) => !tiposBase.includes(t)),
      ];

      let cantidades = null;

      if(this.tipoDatos === "Libras") {
        cantidades = tipos.map((tipo) => parseFloat(datosTipo[tipo].toFixed(0)));
        total = parseFloat(total.toFixed(0));
      } else {
        cantidades = tipos.map((tipo) => datosTipo[tipo]);
      }    

      const unidad = this.tipoDatos === "Libras" ? "£" : "Ventas";

      this.seriesVentasPorTipo = cantidades;
      this.chartVentasPorTipo = {
        chart: {
          type: "bar",
          height: 400,
      events: {
        dataPointSelection: (e, ctx, { dataPointIndex }) => {
          this.$emit("filtrar", { tipo: tipos[dataPointIndex] });
        },
      },
        },
        xaxis: {
          categories: tipos,
          labels: {
            style: {
              colors: "#ffffff",
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#ffffff"],
            fontWeight: "bold",
          },
        },
        tooltip: {
          y: {
            formatter: (val) => `${val} ${unidad}`,
          },
        },
        title: {
          text: `Ventas por Tipo de Producto (${this.tipoDatos === 'Libras' ? '£' + total.toFixed(0) : total + ' unidades'})`,
          align: "middle",
        },
        //colors: this.coloresGrafica,
      };
    },
    calcularGraficaTendencia() {
      const ventasPorFecha = {};
      let total = 0;

      this.orders.forEach(order => {
        if (!order.created_at) return;

        const fecha = new Date(order.created_at);
        if (isNaN(fecha)) return;

        const fechaStr = fecha.toISOString().split('T')[0];

        if (!ventasPorFecha[fechaStr]) ventasPorFecha[fechaStr] = 0;

        order.line_items.forEach(item => {
          const precio = parseFloat(item.price) || 0;
          const cantidad = Number(item.quantity) || 0;
          const importe = precio * cantidad;

          if (this.tipoDatos === "Libras") {
            ventasPorFecha[fechaStr] += importe;
            total += importe;
          } else {
            ventasPorFecha[fechaStr] += cantidad;
            total += cantidad;
          }
        });
      });

      const fechas = Object.keys(ventasPorFecha).sort();
      const cantidades = this.tipoDatos === "Libras"
        ? fechas.map(fecha => parseFloat(ventasPorFecha[fecha].toFixed(0)))
        : fechas.map(fecha => ventasPorFecha[fecha]);

      const unidad = this.tipoDatos === "Libras" ? "£" : "ventas";

      this.seriesVentasPorFecha = [
        {
          name: this.tipoDatos,
          data: cantidades,
        },
      ];

      this.chartVentasPorFecha = {
        chart: {
          type: "line",
          height: 400,
          zoom: {
            enabled: true,
          },
        },
        title: {
          text: `Tendencia de Ventas en el Tiempo (${this.tipoDatos === "Libras" ? "£" + total.toFixed(0) : total + " ventas"})`,
          align: "middle",
        },
        xaxis: {
          categories: fechas,
          title: {
            text: "Fecha",
          },
          labels: {
            style: {
              colors: "#ffffff",
            },
          },
        },
        yaxis: {
          title: {
            text: this.tipoDatos,
          },
          labels: {
            style: {
              colors: "#ffffff",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        tooltip: {
          y: {
            formatter: (val) => `${val} ${unidad}`,
          },
        },
        colors: [this.coloresGrafica[0]],
      };
    },
    calcularGraficaTendenciaPais() {
      const pais = this.paisSeleccionado;
      const ciudad = this.ciudadSeleccionada ? this.ciudadSeleccionada.toLowerCase() : null;
      const ventasPorFecha = {};
      let total = 0;

      this.orders.forEach(order => {
        if (!order.created_at) return;

        const country = order.shipping_address?.country;
        if (country !== pais) return;

        const city = order.shipping_address?.city;
        if (city.toLowerCase() !== ciudad && ciudad != 'todas') return;

        const fecha = new Date(order.created_at);
        if (isNaN(fecha)) return;

        const fechaStr = fecha.toISOString().split('T')[0];

        if (!ventasPorFecha[fechaStr]) ventasPorFecha[fechaStr] = 0;

        order.line_items.forEach(item => {
          const precio = parseFloat(item.price) || 0;
          const cantidad = Number(item.quantity) || 0;
          const importe = precio * cantidad;

          if (this.tipoDatos === "Libras") {
            ventasPorFecha[fechaStr] += importe;
            total += importe;
          } else {
            ventasPorFecha[fechaStr] += cantidad;
            total += cantidad;
          }
        });
      });

      const fechas = Object.keys(ventasPorFecha).sort();
      const cantidades = this.tipoDatos === "Libras"
        ? fechas.map(fecha => parseFloat(ventasPorFecha[fecha].toFixed(0)))
        : fechas.map(fecha => ventasPorFecha[fecha]);

      const unidad = this.tipoDatos === "Libras" ? "£" : "ventas";

      this.seriesVentasPorFechaPais = [
        {
          name: this.tipoDatos,
          data: cantidades,
        },
      ];

      this.chartVentasPorFechaPais = {
        chart: {
          type: "line",
          height: 400,
          zoom: {
            enabled: true,
          },
        },
        title: {
          text: `Tendencia de Ventas en el Tiempo en ${pais} ${ciudad == 'todas'? '': '- '+ciudad} (${this.tipoDatos === "Libras" ? "£" + total.toFixed(0) : total + " ventas"})`,
          align: "middle",
        },
        xaxis: {
          categories: fechas,
          title: {
            text: "Fecha",
          },
          labels: {
            style: {
              colors: "#ffffff",
            },
          },
        },
        yaxis: {
          title: {
            text: this.tipoDatos,
          },
          labels: {
            style: {
              colors: "#ffffff",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        tooltip: {
          y: {
            formatter: (val) => `${val} ${unidad}`,
          },
        },
        colors: [this.coloresGrafica[0]],
      };
    },

    calcularTopProductos(n = 10) {
  const productos = {};
  let total = 0;

  this.orders.forEach(order => {
    order.line_items.forEach(item => {
      const nombre = item.name || 'Producto desconocido';
      const precio = parseFloat(item.price) || 0;
      const cantidad = Number(item.quantity) || 0;
      const importe = precio * cantidad;

      if (!productos[nombre]) productos[nombre] = 0;

      if (this.tipoDatos === "Libras") {
        productos[nombre] += importe;
        total += importe;
      } else {
        productos[nombre] += cantidad;
        total += cantidad;
      }
    });
  });

  const topProductos = Object.entries(productos)
    .sort((a, b) => b[1] - a[1])
    .slice(0, n);

  const labels = topProductos.map(([nombre]) => nombre);
  const series = this.tipoDatos === "Libras"
    ? topProductos.map(([_, valor]) => parseFloat(valor.toFixed(0)))
    : topProductos.map(([_, valor]) => valor);

  const unidad = this.tipoDatos === "Libras" ? "£" : "Ventas";

  this.seriesTopProductos = series;
  this.chartTopProductos = {
    chart: {
      type: "bar",
      height: 400,
      events: {
        dataPointSelection: (e, ctx, { dataPointIndex }) => {
          this.$emit("filtrar", { producto: labels[dataPointIndex] });
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
      }
    },
    dataLabels: {
      enabled: true,
      style: {
        fontWeight: "bold",
        colors: ["#ffffff"],
      },
    },
    tooltip: {
      y: {
        formatter: val => `${val} ${unidad}`
      }
    },
    xaxis: {
      categories: labels,
      labels: {
        style: {
          colors: "#ffffff"
        }
      }
    },
    colors: this.coloresGrafica,
    title: {
      text: `Top ${n} Productos Más Vendidos (${this.tipoDatos === 'Libras' ? '£' + total.toFixed(0) : total + ' unidades'})`,
      align: "middle",
    },
    legend: {
      show: false,
    },
  };
},
calcularGraficaTopProductosPais() {
  const pais = this.paisSeleccionado;
  const productos = {};
  let total = 0;

  this.orders.forEach(order => {
    const country = order.shipping_address?.country;
    if (country !== pais) return;

    order.line_items.forEach(item => {
      const nombre = item.name || "Producto desconocido";
      const precio = parseFloat(item.price) || 0;
      const cantidad = Number(item.quantity) || 0;
      const importe = precio * cantidad;

      if (!productos[nombre]) productos[nombre] = 0;

      if (this.tipoDatos === "Libras") {
        productos[nombre] += importe;
        total += importe;
      } else {
        productos[nombre] += cantidad;
        total += cantidad;
      }
    });
  });

  const topProductos = Object.entries(productos)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);

  const nombres = topProductos.map(([nombre]) => nombre);
  const cantidades = this.tipoDatos === "Libras"
    ? topProductos.map(([, valor]) => parseFloat(valor.toFixed(0)))
    : topProductos.map(([, valor]) => valor);

  const unidad = this.tipoDatos === "Libras" ? "£" : "unidades";

  this.seriesTopProductosPais = cantidades;

  this.chartTopProductosPais = {
    chart: {
      type: "bar",
      height: 400,
      events: {
        dataPointSelection: (e, ctx, { dataPointIndex }) => {
          this.$emit("filtrar", { pais, producto: nombres[dataPointIndex] });
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
      }
    },
    dataLabels: {
      enabled: true,
      style: {
        fontWeight: "bold",
        colors: ["#ffffff"],
      },
    },
    xaxis: {
      categories: nombres,
    },
    title: {
      text: `Top Productos en ${pais} (${this.tipoDatos === "Libras" ? "£" + total.toFixed(0) : total + " unidades"})`,
      align: "center"
    },
    tooltip: {
      y: {
        formatter: val => `${val} ${unidad}`
      }
    },
    legend: {
      show: false,
    },
    colors: this.coloresGrafica
  };
},

calcularGraficaPorTipoProductoPais() {
  const pais = this.paisSeleccionado;
  const datosTipo = {};
  let total = 0;

  const tiposBase = ["Sleeves", "Accessories", "Bags", "Wallets"];
  const tiposSet = new Set(tiposBase);

  this.orders.forEach((order) => {
    const country = order.shipping_address?.country;
    if (country !== pais) return;

    order.line_items.forEach((item) => {
      const tipo = item.product_type?.trim() || "Desconocido";
      if (tipo === "Desconocido") return;

      tiposSet.add(tipo); // asegurar el tipo

      const precio = parseFloat(item.price) || 0;
      const cantidad = Number(item.quantity) || 0;
      const importe = precio * cantidad;

      if (!datosTipo[tipo]) datosTipo[tipo] = 0;

      if (this.tipoDatos === "Libras") {
        datosTipo[tipo] += importe;
        total += importe;
      } else {
        datosTipo[tipo] += cantidad;
        total += cantidad;
      }
    });
  });

  // Asegurar los tipos base con cero si no aparecieron
  tiposBase.forEach((tipo) => {
    if (!datosTipo[tipo]) datosTipo[tipo] = 0;
  });

  const tipos = [
    ...tiposBase,
    ...[...tiposSet].filter((t) => !tiposBase.includes(t)),
  ];

  const cantidades = this.tipoDatos === "Libras"
    ? tipos.map((tipo) => parseFloat((datosTipo[tipo] || 0).toFixed(0)))
    : tipos.map((tipo) => datosTipo[tipo]);

  const unidad = this.tipoDatos === "Libras" ? "£" : "ventas";

  this.seriesVentasPorTipoPais = cantidades;

  this.chartVentasPorTipoPais = {
    chart: {
      type: "bar",
      height: 400,
      events: {
        dataPointSelection: (e, ctx, { dataPointIndex }) => {
          this.$emit("filtrar", { pais, tipo: tipos[dataPointIndex] });
        },
      },
    },
    xaxis: {
      categories: tipos,
      labels: {
        style: {
          colors: "#ffffff",
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#ffffff"],
        fontWeight: "bold",
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} ${unidad}`,
      },
    },
    title: {
      text: `Ventas por Tipo en ${pais} (${this.tipoDatos === "Libras" ? "£" + total.toFixed(0) : total + " ventas"})`,
      align: "middle",
    },
    //colors: this.coloresGrafica,
  };
},
calcularOpcionesCiudades() {
  const pais = this.paisSeleccionado;
  const totalPorCiudad = {};

  // 1. Calcular totales por ciudad dependiendo de tipoDatosCalcular
  this.orders.forEach((order) => {
    const country = order.shipping_address?.country;
    if (country === pais) {
      const city = order.shipping_address?.city || "Desconocida";
      const cityKey = city.trim().toLowerCase();

      if (!totalPorCiudad[cityKey]) {
        totalPorCiudad[cityKey] = { total: 0, nombre: city };
      }

      order.line_items.forEach((item) => {
        if (this.tipoDatosCalcular === "Ventas") {
          // Sumar cantidad de ítems
          totalPorCiudad[cityKey].total += item.quantity;
        } else if (this.tipoDatosCalcular === "Libras") {
          // Sumar valor en libras (precio * cantidad)
          totalPorCiudad[cityKey].total += item.price * item.quantity;
        }
      });
    }
  });

  // 2. Ordenar ciudades según el total calculado
  const ciudadesOrdenadas = Object.values(totalPorCiudad)
    .sort((a, b) => b.total - a.total)
    .map((c) => c.nombre.charAt(0).toUpperCase() + c.nombre.slice(1).toLowerCase());

  // 3. Generar opciones del selector
  this.opcionesCiudades = [
    { text: "Todas", value: "todas" },
    ...ciudadesOrdenadas.map((ciudad) => ({
      text: ciudad,
      value: ciudad,
    })),
  ];

  // 4. Seleccionar la ciudad con mayor ventas/importe por defecto
  if (!this.ciudadSeleccionada && this.opcionesCiudades.length > 0) {
    this.ciudadSeleccionada = this.opcionesCiudades[0].value;
  }
}


  },
  watch: {
    items() {
      this.orders = this.items;

      // 1. Calcular totales por país
      const totalPorPais = {};
      this.orders.forEach((order) => {
        const country = order.shipping_address?.country || "Desconocido";
        order.line_items.forEach((item) => {
          if (!totalPorPais[country]) totalPorPais[country] = 0;
          totalPorPais[country] += item.quantity;
        });
      });

      // 2. Ordenar países por total de ventas (de mayor a menor)
      const paisesOrdenados = Object.entries(totalPorPais)
        .sort((a, b) => b[1] - a[1])
        .map(([pais]) => pais);

      // 3. Generar opciones del selector
      this.opcionesPaises = paisesOrdenados.map((pais) => ({
        text: pais,
        value: pais,
      }));

      // 4. Seleccionar el país con más ventas por defecto
      if (!this.paisSeleccionado && this.opcionesPaises.length > 0) {
        this.paisSeleccionado = this.opcionesPaises[0].value;
      }

      // 5. Calcular gráfica
      this.calcularGraficaPorCiudad();

      this.calcularGraficaPorTipoProducto();
      this.calcularGraficaTendencia();

      this.calcularGraficaTendenciaPais();

      this.calcularTopProductos();

      this.calcularGraficaTopProductosPais();
      this.calcularGraficaPorTipoProductoPais();

      this.calcularOpcionesCiudades();
    },
    paisSeleccionado() {
      //Calcular las ciudades del país seleccionado
      
      this.calcularOpcionesCiudades();

      this.calcularGraficaPorCiudad();
      this.calcularGraficaTopProductosPais();
      this.calcularGraficaPorTipoProductoPais();
      this.calcularGraficaTendenciaPais();
    },
    ciudadSeleccionada() {
      this.calcularGraficaTendenciaPais();
    },
    tipoDatosCalcular() {
      this.tipoDatos = this.tipoDatosCalcular;
      this.calcularOpcionesCiudades();
      this.calcularGraficaPorTipoProducto();
      this.calcularGraficaTendencia();
      this.calcularGraficaTendenciaPais();
      this.calcularTopProductos();
      this.calcularGraficaPorCiudad();
      this.calcularGraficaTopProductosPais();
      this.calcularGraficaPorTipoProductoPais();
      
    },
  },
};
</script>
  
  <style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-slider.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.grafica-ciudades .select-moderno {
  legend {
    font-size: 12px;
    font-weight: 600;
    color: #64748B;
    letter-spacing: 0.02em;
  }
  .v-select .vs__dropdown-toggle {
    min-height: 40px;
    padding: 0 6px;
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    background: #fff;
    transition: border-color 150ms ease, box-shadow 150ms ease;
  }
  .v-select.vs--open .vs__dropdown-toggle,
  .v-select .vs__dropdown-toggle:focus-within {
    border-color: #3B82F6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
  }
  .vs__selected { font-weight: 600; color: #1E293B; padding: 0 6px; }
  .vs__search { padding: 0 6px; }
  .vs__open-indicator { fill: #94A3B8; transform: scale(0.8); }
  .vs__dropdown-menu {
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
    padding: 6px;
    max-height: 320px;
  }
  .vs__dropdown-option {
    padding: 8px 10px;
    border-radius: 6px;
    font-size: 13px;
    color: #334155;
  }
  .vs__dropdown-option--highlight { background: #EFF6FF; color: #2563EB; }
  .vs__dropdown-option--selected { font-weight: 600; color: #2563EB; }
}

// Vuexy pinta las etiquetas de ApexCharts con el color del body; aquí van sobre barras de color
.grafica-ciudades .apexcharts-bar-series .apexcharts-datalabels .apexcharts-datalabel {
  fill: #fff !important;
}
.grafica-ciudades .apexcharts-bar-area,
.grafica-ciudades .apexcharts-pie-area { cursor: pointer; }
</style>